import React from "react";

type Props = {};

/**
 * A wrapper around children that are the main content for the create page.
 * Primary used to enforce a single main section.
 */
export const CreatePageV2MainSection: React.FC<Props> = (props) => {
  return <>{props.children}</>;
};

CreatePageV2MainSection.displayName = "CreatePageV2MainSection";
